import { render, staticRenderFns } from "./BillingResume.vue?vue&type=template&id=99fdf74e"
import script from "./BillingResume.vue?vue&type=script&lang=js"
export * from "./BillingResume.vue?vue&type=script&lang=js"
import style0 from "./BillingResume.vue?vue&type=style&index=0&id=99fdf74e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports